<div class="tabs">
  <ul class="tabs__list">
    @for (tab of tabs(); track tab) {
      <li #itemRef class="tabs__item" [class.active]="tab === activeTabComponent" (click)="activateTab(tab, itemRef)">
        <span class="tabs__title">{{ tab.title() }}</span>
      </li>
    }
  </ul>

  @if (activeTabComponent?.actionsRef()) {
    <div class="tabs__actions">
      <ng-template [ngTemplateOutlet]="activeTabComponent.actionsRef()" />
    </div>
  }
</div>

@if (activeTabComponent?.contentRef()) {
  <div class="tabs__content">
    <ng-template [ngTemplateOutlet]="activeTabComponent.contentRef()" />
  </div>
}
